<script setup>
import { computed, defineProps, defineEmits } from 'vue'

const props = defineProps({
    title: { type: String, required: true },
    subtitle: { type: String, default: '' },
    link: { type: String, default: '' },
    showSwitch: { type: Boolean, default: false },
    modelValue: { type: Boolean, default: false },
    enabledText: { type: String, default: 'Habilitado' },
    disabledText: { type: String, default: 'Desabilitado' }
})

const emit = defineEmits(['update:modelValue'])

const switchValue = computed({
    get: () => props.modelValue,
    set: (value) => emit('update:modelValue', value)
})
</script>

<template>
  <div class="page-card">
    <div class="page-card__header d-flex flex-column ga-2 pb-6">
      <div class="page-card__header-top">
        <h2 class="page-card__title">{{ title }}</h2>
        <div v-if="showSwitch" class="page-card__switch-container">
          <rb-switch
            v-model="switchValue"
            class="page-card__switch"
          />
        <span class="page-card__switch-label">
            {{ switchValue ? enabledText : disabledText }}
        </span>
        </div>
      </div>
      <div class="page-card__subtitle" v-if="subtitle || link">
        <p class="page-card__subtitle-text">{{ subtitle }}</p>
        <a v-if="link" :href="link" class="page-card__subtitle-link">Saiba mais</a>
      </div>
    </div>
    <div class="page-card__body">
      <slot />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.page-card {
    background-color: #fff;
    height: 100%;
    padding: 32px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    border-radius: 8px;

    &__header {
        &-top {
            display: flex;
            gap: 24px;
            align-items: center;
        }
    }

    &__title {
        font-family: Poppins, sans-serif;
        font-size: 32px;
        font-weight: 600;
        margin: 0;
        color: rgb(var(--v-theme-primary-60));
    }

    &__switch-container {
        display: flex;
        align-items: center;
        gap: 12px;
    }

    &__switch-label {
        font-family: Roboto, sans-serif;
        font-size: 16px;
        font-weight: 400;
        color: var(--v-theme-text-neutral-primary);
    }

    &__subtitle {
        font-family: Roboto, sans-serif;
        display: flex;
        align-items: center;
        gap: 8px;

        &-text {
            font-size: 16px;
            font-weight: 400;
            line-height: 24px;
            margin: 0;
            letter-spacing: 0.5px;
            color: var(--v-theme-text-neutral-primary);
        }

        &-link {
            color: rgb(var(--v-theme-primary-60));
        }
    }

    &__body {
        display: flex;
        flex-direction: column;
        gap: 16px;
    }
}
</style>